// @givmo/board — the director door: "Sign in" (CBG-SEC2; mockup 2, frame `m2-door`).
//
// Where the director family's guard sends a signed-out visitor — reached from a packet notice, a
// bookmark, or the invitation page's "Already joined? Sign in" — with `redirect` naming where they
// were going. It is the host's ways in, in the director's register: the same set the invitation
// shows, equal in weight, because which way is right depends only on the account the director
// already has. A heading and one line, and no prose on the chooser (a credential screen that argues
// its own trustworthiness reads as one that needs to).
//
// CBG-FIX106 (the FIX104 copy page's row 4.7, approved 2026-10-17 17:42 PDT): the door is shown
// before Board knows whose seat it is, and a committee's emails bring its members here too, so it
// says "Sign in" and "Use the Givmo account you joined with.", true of a board's seat and a
// committee's (it said "Sign in to your board" and "…you joined your board with.").

import { useSearch } from '../../board-routing';
import { BOARD_DIRECTOR_PAGES } from '../../board-routes';
import { boardPath } from '../../board-routing';
import { useBoardBasePath } from '../../board-runtime';
import { useBoardDirectorHost } from '../../director/director-host';
import { DirectorShell } from './director-shell';

export function DirectorDoorPage() {
  const { renderWaysIn } = useBoardDirectorHost();
  const basePath = useBoardBasePath();
  const search = useSearch();
  const returnTo =
    typeof search.redirect === 'string' && search.redirect.length > 0
      ? search.redirect
      : boardPath(basePath, BOARD_DIRECTOR_PAGES.home);

  return (
    <DirectorShell
      title="Sign in"
      description="Use the Givmo account you joined with."
      testId="page-director-door"
    >
      {renderWaysIn({ arrival: 'door', returnTo })}
    </DirectorShell>
  );
}
